/* =============================================================
   WATERMARK CONFIG

   The text tiled faintly over the content area of every signed-in
   page (src/jsx/layouts/Watermark.jsx). Read when the app loads.

   - Change the text here. It is bundled into the build, so restart
     the dev server or rebuild for a change to show.
   - An empty string ("") turns the watermark off.
   ============================================================= */

export const WATER_MARK = "SEVEN MENTOR";

/* =============================================================
   COMING SOON FEATURES

   Route urls (as written in src/jsx/index.jsx, without the leading
   slash) that are hidden from EVERYONE, administrators included, until
   they are removed from this list. A listed url:

   - is not registered as a route, so opening it shows the 404 page;
   - disappears from the sidebar and from the topbar search;
   - takes its other entry points with it (e.g. "access-center" also
     hides the account menu's Request access link and the admin
     dashboard's Access tab).

   Matching ignores case and leading/trailing slashes, and a listed url
   also hides everything under it ("setting" would hide
   "setting/list-user"). Checked by src/utils/comingSoon.js. Rebuild or
   restart the dev server after a change.
   ============================================================= */

export const COMING_SOON_FEATURES = [
  "access-center",
];
